import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18DateFormat00 from './C18DateFormat00'
import C18Button00 from './C18Button00'
import C18Anchor00 from './C18Anchor00'
import C18Duration00 from './C18Duration00'
import {getParamId,getParamId2,getParamId800,getPearlUsed,get800Used, wsTrans,isHydroRoot16} from '../utils/utils'
import {loadSitesInfo,loadZonesInfo,getZoneIndex,loadSiteData,getChannelType,
  acctFeature
} from './C18utils'
import {getEquipmentStatus} from './C18EquipmentStatus00'
import {dbVals,getZoneControllers,sendArray} from '../../components/utils/http';
import {cl,globs,dateToDisplayDate,getTime,constant,secsToDisplayDate,interpolateColor,isHydroR,isPearlFwAtLeast} from '../../components/utils/utils';
import {pInd} from '../../components/utils/paramIds';
import {chTypes} from '../../fui/utilsFui'
import {getHR16InfoText, processHR16Countdown} from './C18IrrigationInfo'
import C18HydroRootStatusBar from './C18HydroRootStatusBar'
import {lc} from '../../components/utils/landruConstants'

import history from "../../history"
import DateFnsUtils from '@date-io/date-fns'
import C18MuiPickersUtilsProvider from './C18MuiPickersUtilsProvider'
import C18MuiTimePicker from './C18MuiTimePicker'
import { color } from 'd3';

/** Real station row (Pearl walk valve skips these gaps). Safe to call from constructor before instance fields exist. */
const isConfiguredEquipmentChannel = (e) => {
  if (!e) return false
  if (e.chType === "channel_None") return false
  if (+e.type === +constant.EQ_NONE) return false
  return true
}

class C18ZoneEquipment00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this._cdEpochs = {}
    this.getEquipment()
    this.state={
      mode:"sites",
      zInd:0,
      cols: 1,
      equipment:[
      {id:1, name:"Exhaust Variable Speed",system:"ON"},
      {id:2, name:"Water Valve 1",system:"ON"},
      {id:3, name:"North Roof Vents",system:"ON"},
      {id:4, name:"Water Pump",system:"ON - 60%"},
      {id:5, name:"Tank Fill Valve",system:"ON - 60%"},
      {id:6, name:"LED Grow Lights",system:"ON - 60%"},
      {id:7, name:"Floor Hot Water Valve",system:"OFF"},
      {id:8, name:"Fl Bl",system:"OFF"},
      {id:9, name:"Fl Nt",system:"OFF"},
      {id:11, name:"K Blo",system:"ON"},
      {id:12, name:"Fl Ki",system:"ON"},
      {id:13, name:"pH Up",system:"OFF"},
      {id:15, name:"pH Dn",system:"OFF"},
      {id:16, name:"Tank 2",system:"ON"},
      {id:17, name:"Gable Exhaust Fans",system:"OFF",alarm:true},
      {id:18, name:"Tank 4",system:"ON"},
      ],
      loaded:false,
      updateInterval: setInterval(this.update,1000),
      checkMqttInterval: setInterval(this.checkMqtt,5000),

      showEquipment:true,
      hideEquipment: globs.zonesInfo.info[getZoneIndex(this.props.parms.zone)]?.hideEquipment,
      zoneId: globs.zonesInfo.info[getZoneIndex(this.props.parms.zone)]?.zoneId,
      eqList: [],
      filteredEquipment: [],
      showWaterNow: false,
      waterNowChannelId: "",
      waterNowDuration: 0,
      zoneInfo: null,
      waterNowActiveChan: null,
      waterNowPending: false,
      waterNowPendingTO: null,
      rainSkipOpen: false,
      rainSkipValue: 7,
      rainSkipUnit: "days",
      rainSkipActive: false,
      rainSkipEndTime: 0,
      rainSkipStopping: false,
      rainSkipPending: false,
      rainSkipPendingSince: 0,
      waterBudgetOpen: false,
      waterBudgetPct: 100,
      waterBudgetDays: 7,
      waterBudgetActive: false,
      waterBudgetEndTime: 0,
      showWalkValve: false,
      walkValveStartCh: "",
      walkValveEndCh: "",
      walkValveDuration: 15,
      walkValveActiveChan: null,
      walkValvePending: false,
      walkValvePendingTO: null,
      actionsExpanded: false,
      auxActive: false,
      auxWbPct: 0,
      auxWbActive: false,
    }
//     setInterval(this.update,1000)
  }
  
  update=()=>{
//     cl("update")
    this.getEquipment()
  }
  
  componentWillUnmount=()=>{
    clearInterval(this.state.updateInterval)
    clearInterval(this.state.checkMqttInterval)
    if(this.state.waterNowPendingTO){clearTimeout(this.state.waterNowPendingTO)}
    if(this.state.walkValvePendingTO){clearTimeout(this.state.walkValvePendingTO)}
  }
  
  getZoneIndex=(zoneId)=>{// returns the siteZoneIndex
    for(let i=0;i<globs.zonesInfo.info.length;i++){
      let z=globs.zonesInfo.info[i]
      if(z.zoneId==zoneId){
//         cl(z)
        return z.siteZoneIndex}
    }
  }
  
//   getPearlUsed=(zInd,zInfo)=>{
// //     cl("get pearl")
//     let xBoards=[]
//     let numOutId=getParamId2(zInfo.gatewayType,"configuration_expansion_boards","numOutputs")
//     let chIndex=getParamId2(zInfo.gatewayType,"configuration_expansion_boards","startChannelIndex")
//     let addIndex=getParamId2(zInfo.gatewayType,"configuration_expansion_boards","address")
//
//
//     let mult=pInd[1900].config_expansion_boards[2]
// //     cl(mult)
// //     cl(numOutId)
// //     cl(dbVals.z[zInd][240][addIndex])
// //     cl(chIndex)
//     for(let i=0;i<40;i++){
//       xBoards.push({
//         numOut:+((dbVals.z[zInd]||{})[240]||{})[numOutId+i*mult]||0,
//         chInd:+((dbVals.z[zInd]||{})[240]||{})[chIndex+i*mult]||0,
//       })
//     }
// //     cl(xBoards)
// //     cl(xBoards[0])
// //     if(xBoards[0].numOut==0){
// //       xBoards[0].numOut=8
// //       xBoards[0].chInd=0
// //       xBoards[1].numOut=4
// //       xBoards[1].chInd=8
// //     }
//     let ret=[]
//     xBoards.forEach(x=>{
//       if((+x.numOut)>0){
//         for(let i=0;i<x.numOut;i++){
//           ret.push(x.chInd+i)
//         }
//       }
//     })
// //     cl(xBoards)
//     return ret
//   }
  getUsedChannels=(zInd,zInfo)=>{
//     cl(zInfo)
//     let gotExpansion=false
    let zc=getZoneControllers(zInd)
//     cl(zc)
    let ret=[]
    let chUsedId=getParamId("configuration_channels","used")
    var used
    if(zInfo.virtual){
      let max=(zInfo.virtualType=="expLink4")?22:12
      if(zInfo.virtualType=="iGrow800"){max=8}
      if(zInfo.virtualType=="hydroroot16"){max=16}
      if(zInfo.virtualType=="pearl"){return getPearlUsed(zInd,zInfo)}
//       cl(zInfo)
      for(let i=0;i<max;i++)
        if((zInfo.virtualType=="hydroroot16")||(i<12)||(i>=16))
          {ret.push(i)}
    }else{
//       cl(zInfo)
      if(zInfo.gatewayType==1900){return getPearlUsed(zInd,zInfo)}
      if(zInfo.gatewayType==800){return get800Used(zInd,zInfo)}
//         cl(ret)q
//         cl(ret)
//         ret=[]
//       }else{
      for(let i=0;i<160;i++){
        if(+zc[Math.floor(i/40)]){
          if((zInfo.gatewayType==1900)||(zInfo.gatewayType==800)){
            used=(i<8)?1:0
          }else{
            used=((dbVals.z[zInd]||{})[i]||{})[chUsedId]||0
          }
          if(+used){ret.push({chInd:i})}
        }
      }
//       }
    }
    return ret
  }

  getEquipment800=async(zInd,zInfo,chans)=>{
//     cl(chans)
//     cl(dbVals)
    let chTypeId=getParamId800("igCE","channelType")
    let chNameId=getParamId800("igCE","channelName")
    let chPosId=getParamId800("igRE","position")
    let chOvrOne=getParamId800("igCE","oneChannelOverride")
    let chOvrTwo=getParamId800("igCE","twoChannelOverrideMode")
    let chOvrTwoPos=getParamId800("igCE","twoChannelOverridePosition")

    let proport=[constant.EQ_800_VENT, constant.EQ_800_CURTAIN]
//     cl(chTypeId)
//     cl(dbVals,zInd)
//     cl(chans)
    let equip=[]
    chans.forEach((c,i)=>{
      if((dbVals.z[zInd]||[])[i]){
        let chTypeInd=dbVals.z[zInd][i][chTypeId]
        let chType=getChannelType(zInfo.gatewayType, zInd,i)
        let ch=dbVals.z[zInd][i]
        let pos=ch[chPosId]
        let off=(proport.includes(+(ch||{})[chTypeId]))?"0%":"OFF"
        let on=(proport.includes(+(ch||{})[chTypeId]))?"1%":"ON"
        if(pos==99){pos=100}
        let system=(pos!=undefined)?((pos==0)?off:((pos==1)?on:`${pos}%`)):"None"
        let status=getEquipmentStatus(zInfo.gatewayType,zInd,i,ch,0,0)
//         cl(status)
        let eq={
          name:/*dbVals.z[zInd][i]*/ch[chNameId],
          type:chTypeInd,
          chType:chType,
          pos:pos,
          system:system,
          status:status,
          showInfo:(this.state.equipment[i]||{}).showInfo,
          id:i+1,
          unit:0,
          chan:i,
        }
        equip[i]=eq
      }
    })
//     cl(equip)
    let filteredEquipment = this.filterEquipment(equip,
      this.state.hideEquipment);
    this.setState({zInd: zInd, equipment: equip,
      filteredEquipment:filteredEquipment,loaded: true, zoneInfo: zInfo})
  }

//   get800Equipment=(zInfo)=>{
//     cl(zInfo)
// //     this.setState({zInd: zInfo.siteZoneIndex, equipment: equip, loaded: true})
//   }

  getShowSwPos=(zInfo)=>{
// "Enable Demands" is poorly named. It's actually
//     CTRLCFG_ID_ZONE_SETUP_SETUPFLAGS
    let zoneFlagsId=getParamId2(zInfo.gatewayType,
      "zone_configuration_settings","Enable Demands Based on Active Cool")
// <<<<<<< HEAD
//     if (dbVals.z[zInfo.siteZoneIndex]) {
//       let flags=(dbVals.z[zInfo.siteZoneIndex][255]||{})[zoneFlagsId]
//       return flags&constant.CTRLCFG_ID_ZONE_SETUP_SETUPFLAGS_DIS_SW_POS
// =======
    if (dbVals.z[zInfo.siteZoneIndex] && dbVals.z[zInfo.siteZoneIndex][255]) {
      return dbVals.z[zInfo.siteZoneIndex][255][zoneFlagsId]&
      constant.CTRLCFG_ID_ZONE_SETUP_SETUPFLAGS_DIS_SW_POS
// >>>>>>> 60293866cf68ca1c7314167dd75856401aefe9dd
    }
//     cl(disableSwPos)
  }

  checkMqtt=async()=>{
    let st=this.state
    let pa=this.props.parms
    if(pa.gwType!=1900){return}
    let contFlagsId=getParamId2(1900,"pearl_snaps","errorFlags")
    let chFlagsId=getParamId2(1900,"pearl_chan_anx_stat","eqFlags")
    let zone=globs.zonesInfo.info.find(z=>z.zoneId==pa.zone)
    let chans=getPearlUsed(st.zInd)
    let sysFlags=((dbVals.z[st.zInd]||{})[240]||{})[contFlagsId]||0
    let openCircuitChans=[]
    let shortCircuitChans=[]
    chans.forEach(c=>{
      let chFlags=((dbVals.z[st.zInd]||{})[c.chInd]||{})[chFlagsId]||0
      if(chFlags&lc.EQ_FLAGS_OPEN_CIRCUIT){openCircuitChans.push(c.chInd+1)}
      if(chFlags&lc.EQ_FLAGS_SHORT){shortCircuitChans.push(c.chInd+1)}
    })
    let fuseBlown=!!(sysFlags&lc.STATUS_ERROR_BLOWN_FUSE)
//     let expansionOffline=false
    let boardTypeId=getParamId2(1900,"configuration_expansion_boards","boardType")
    let boardStatusId=getParamId2(1900,"snapshot_expansion_boards","boardStatus")
    let xbCfg=pInd[1900].config_expansion_boards
    let xbSnap=pInd[1900].snapshot_expansion_boards
//     cl(xbCfg)
    let xbOffline=[]
    for(let i=0;i<xbCfg[3];i++){
      let bt=+((dbVals.z[st.zInd]||{})[240]||{})[boardTypeId+xbCfg[2]*i]||0
//       cl(i,bt)
      if(bt){
        let bs=((dbVals.z[st.zInd]||{})[240]||{})[boardStatusId+xbSnap[2]*i]||0
//         cl(bs)
//         if(bs!=1){expansionOffline=true}
        if(+bs&&(bs!=1)){xbOffline.push(i+1)}
      }
    }
    let commFailure=!this.state.zoneInfo.virtual&&(getTime()-this.state.zoneInfo.updateTime)>180

    let openStr=openCircuitChans.length?`Channel Open Circuit: ${openCircuitChans.join(", ")}`:""
    let shortStr=shortCircuitChans.length?`Channel Short Circuit: ${shortCircuitChans.join(", ")}`:""
    let fuseStr=fuseBlown?"Blown Fuse Detected":""

    let zoneError=""
    if(commFailure){
      zoneError="Cloud / Controller Connection Error"
    }else if(xbOffline.length){
      zoneError=`Expansion Board${(xbOffline.length>1)?"s":""} Offline: ${xbOffline.join(", ")}`
    }else if(fuseBlown&&(openCircuitChans.length||shortCircuitChans.length)){
      let channelErrStr=[openStr,shortStr].filter(Boolean).join(", ")
      zoneError={primary:fuseStr,secondary:channelErrStr,flash:true}
    }else if(fuseBlown){
      zoneError=fuseStr
    }else if(shortCircuitChans.length){
      zoneError=shortStr
    }else if(openCircuitChans.length){
      zoneError=openStr
    }
    this.props.parms.setZoneError(zoneError)
  }
  
  getEquipment=async()=>{
//     cl(this.props)
    let pa=this.props.parms
//     pa.setZoneError("MQTT Failure")
    await Promise.all([
      loadZonesInfo(),
      loadSiteData(this.props.parms.site),
    ])
//     cl(dbVals.z[2][0][508])
//     await loadZonesInfo()
//     await loadSiteData(this.props.parms.site)
    let zInd=this.getZoneIndex(pa.zone)// *not* the shared version!
    let zInfo=globs.zonesInfo.info[getZoneIndex(pa.zone)]
    let isHR16=isHydroRoot16(zInfo?.zoneId)
    this.disSwPos=this.getShowSwPos(zInfo)
//     cl(zInfo)
//     if(zInfo.gatewayType==800){return this.get800Equipment(zInfo)}
    let chans=this.getUsedChannels(zInd,zInfo)// the actual channel ids.
//     cl(chans[9])
    if(zInfo.gatewayType==800){return this.getEquipment800(zInd,zInfo,chans)}
//     cl(zInfo.gatewayType)
//     cl(this.state)
    let proport=[constant.EQ_VENT, constant.EQ_CURT, constant.EQ_MIXV, constant.EQ_MZONE2, constant.EQ_GEN_PID,
    constant.EQ_VAROUT,constant.EQ_MIXV_AN,constant.EQ_DLI_A]
    let chTypeId=getParamId("configuration_channels","channelType")
    let chNameId=getParamId("configuration_channels","channelName")
    let chPosId=getParamId("snapshot_channels","position")
    let chAnalogId=getParamId("configuration_channels","isAnalog")
    let chOverrideId=getParamId("snapshot_channels","channelOverride")
    let auxEqStatusId=isHR16?getParamId2(1900,"snapshot_channels","auxEquipmentStatus"):null
    let auxOutStatusId=isHR16?getParamId2(1900,"snapshot_channels","auxOutputStatus"):null

//     cl(zInfo)
//     cl(chans)
    let equip=[]
    let i2=1;
//     cl(chans)
    chans.forEach(c=>{
//       cl(c)
//       cl(dbVals.z[2][0][508])
      let i=(typeof c=="object")?c.chInd:c
//       cl(i)
       let zone=dbVals.z[zInd]||{}
       let isProp=proport.includes(+(zone[i]||{})[chTypeId])
       if(true||(zone[i][chTypeId]||0)!=0){
         var ch,pos,system,chType,reportedPos,auto
         if(/*true||*/zone){
          ch=zone[i]||{}
//           cl(ch[chAnalogId])
//           cl(ch)
          pos=+ch[chPosId]||0
          reportedPos=pos
//           if((zInfo.gatewayType==1900)&&(!isProp)){pos=c.relState}
//           cl(pos)
          let off=(isProp)?"0%":"OFF"
          let on=(isProp)?"1%":"ON"
          if(pos==99){pos=100}
          if((ch[chTypeId]||0)==constant.EQ_NONE){
            system="None"
          }else{
            system=(pos!=undefined)?((pos==0)?off:((pos==1)?on:`${pos}%`)):"None"
            if((zInfo.gatewayType==1900)&&
              (ch[chTypeId]!=constant.EQ_NONE)){
              if(!this.disSwPos){
                if(c.swPos){
                  auto = "Auto "+system
                  system=(c.relState?"Force ON":"Force OFF")
                }else{
                  system="Auto "+system
                }
              }else{
//                 cl(c.relState)
                if(isProp){
//                   cl("set system")
                  system=`${pos}%`
                }else{
                  system=(c.relState?"ON":"OFF")
                }
              }
            }else{/*cl("is none")*/}
          }
          // cl(system,c.swPos,c.relState)
//           cl(pos,system)
          chType=getChannelType(zInfo.gatewayType, zInd,i)
          if(zInfo.gatewayType==1900){ch[chAnalogId]=c.type}// used later by getChannelType
//           let analog=(zInfo.gatewayType==1900)?c.type:ch[chAnalogId]
//           cl(analog)
          let chId=(zInfo.gatewayType==1900)?((typeof c=="object")?+c.chInd+1:+c+1):i2
//           cl(chId,isProp,system)
          i2++
          let status=getEquipmentStatus(pa.gwType,zInd,i,ch,c.swPos,c.relState)
//           cl(pa.gwType,zInd,i,c.swPos,c.relState)
//           cl(status)
          // if(status=="On "){system="ON"}
          // cl(status,system)
          let eq={
            id:chId,//i2++,
            name:ch[chNameId],
            type:ch[chTypeId],
            analog:ch[chAnalogId],//analog,//
            chType:chType,
            pos:pos,
            reportedPos: reportedPos,
            system:system,
            swPos:c.swPos,
            relState:c.relState,
            showInfo:(this.state.equipment[i]||{}).showInfo,
            status:(chType=="channel_None")?"None":status,
            unit:0,//Math.floor(i/40),
            chan:i,//i%40,
            auto:auto,
            overrideType:+(ch[chOverrideId]||0),
          }
          if(isHR16){
            let auxEqSt=auxEqStatusId?+(ch[auxEqStatusId]||0):0
            let auxOutSt=auxOutStatusId?+(ch[auxOutStatusId]||0):0
            if(auxEqSt || auxOutSt){
              // cl("AUX debug ch:", i, "chOverride:", ch[chOverrideId],
              //   "auxEqStatus:", auxEqSt, "auxOutStatus:", auxOutSt,
              //   "auxEqVal:", ch[auxEqStatusId+1], "auxOutVal:", ch[auxOutStatusId+1])
              // if(!eq.overrideType){
              //   eq.overrideType=10
              // }
            }
            eq.infoText=getHR16InfoText({ch,chType,zone,zInd})
            eq.infoText=processHR16Countdown(eq.infoText, this._cdEpochs, i)
          }
          // cl(eq)
//           equip.push(eq)
          equip[i]=eq
        }else{
          let eq={id:i2, name:`eq${i2}`, type:0, chType:0, pos:0,
            system:0,showInfo:false,
          }
          i2+=1
//           equip.push(eq)
          equip[i]=eq
        }
      }
    })
//     for(let i=0;i<12;i++){
//     }
    // cl(equip)
    let eqList = this.makeEqList(equip)
//     cl(equip)
    let filteredEquipment = this.filterEquipment(equip, this.state.hideEquipment);
//     cl(zInfo.updateTime)
    let nextState = {
      zInd: zInd,
      equipment: equip,
      eqList: eqList.fullEquip,
      loaded: true,
      filteredEquipment,
      isHR16,
      zoneInfo: zInfo}
    let waterNowEq = equip.find(e=>e && +e.overrideType===25)
    if(waterNowEq){
      if(this.state.waterNowPendingTO){clearTimeout(this.state.waterNowPendingTO)}
      nextState.waterNowPending = false
      nextState.waterNowPendingTO = null
      nextState.waterNowActiveChan = waterNowEq.chan
    }else if(!this.state.waterNowPending && this.state.waterNowActiveChan!=null){
      nextState.waterNowActiveChan = null
    }
    // Highest-index configured channel with override 26 tracks sequential walk (skips None in between).
    let walkValveEq=null
    for(let wi=(equip||[]).length-1;wi>=0;wi--){
      let e=equip[wi]
      if(e&&isConfiguredEquipmentChannel(e)&&+e.overrideType===26){
        walkValveEq=e
        break
      }
    }
    if(walkValveEq){
      if(this.state.walkValvePendingTO){clearTimeout(this.state.walkValvePendingTO)}
      nextState.walkValvePending = false
      nextState.walkValvePendingTO = null
      nextState.walkValveActiveChan = walkValveEq.chan
    }else if(!this.state.walkValvePending && this.state.walkValveActiveChan!=null){
      nextState.walkValveActiveChan = null
    }
    nextState.auxActive = equip.some(e=>e && +e.overrideType===10)
    if(isHR16){
      let aux=this.detectAuxWaterBudget(zInd)
      nextState.auxWbActive=aux.active
      nextState.auxWbPct=aux.pct
      if(aux.active){nextState.auxActive=true}
    }
    if(isHR16 && !this.state.waterBudgetOpen){
      let wbPctPid=getParamId2(1900,"pearl_config","water_budget_pct")
      let wbDaysPid=getParamId2(1900,"pearl_config","water_budget_days")
      // Firmware: waterBudgetDays[0]=days (1–30), waterBudgetDays[1]=UTC end (PID 43). Cloud must
      // use [1] as source of truth when present — same pattern as rain_skip_time / rain_skip_time2.
      // Otherwise after rain skip (or any FW adjustment to the end timestamp) PID 39 can stay at
      // the configured day count while the real countdown diverges from browser-localStorage anchors.
      let wbEndUtcPid=getParamId2(1900,"pearl_config","water_budget_days2")
      let wbPct=+((dbVals.z[zInd]||{})[240]||{})[wbPctPid] 
      // cl("dbVals.z[zInd][240]:", ((dbVals.z[zInd]||{})[240]||{})[wbPctPid])
      let wbDaysVal=+((dbVals.z[zInd]||{})[240]||{})[wbDaysPid]||0
      let wbEndUtc=+((dbVals.z[zInd]||{})[240]||{})[wbEndUtcPid]||0
      let now=Math.floor(Date.now()/1000)
      let zoneIdKey=this.state.zoneId||(globs.zonesInfo.info[zInd]||{}).zoneId||""
      // cl("Water Budget debug: wbPctPid:", wbPctPid, "wbDaysPid:", wbDaysPid,
      //   "wbPct:", wbPct, "wbDaysVal:", wbDaysVal, "now:", now)
      if((this.state.waterBudgetActive && this.state.waterBudgetEndTime && now>=this.state.waterBudgetEndTime)){
        nextState.waterBudgetActive=false
        nextState.waterBudgetEndTime=0
      }
      if(wbPct===100){
        // Budget is off (cancelled or naturally finished). Clear any stale local anchor so a
        // fresh budget started later doesn't reuse the old end-time.
        nextState.waterBudgetPct=100
        nextState.waterBudgetActive=false
        nextState.waterBudgetEndTime=0
        try{localStorage.removeItem(`wbEndTime:${zoneIdKey}`)}catch(e){}
      }else if(wbEndUtc>now){
        let days=(wbDaysVal>0 && wbDaysVal<1000000000)
          ? Math.min(30, Math.max(1, Math.round(wbDaysVal)))
          : 7
        try{
          localStorage.setItem(`wbEndTime:${zoneIdKey}`,
            JSON.stringify({e:wbEndUtc, p:wbPct, d:days}))
        }catch(e){}
        nextState.waterBudgetPct=wbPct
        nextState.waterBudgetEndTime=wbEndUtc
        nextState.waterBudgetActive=true
      }else if(wbDaysVal>1000000000 && wbDaysVal>now){
        // Legacy: older builds packed UTC end into PID 39 instead of PID 43.
        nextState.waterBudgetPct=wbPct
        nextState.waterBudgetEndTime=wbDaysVal
        nextState.waterBudgetActive=(wbPct!==100 && wbDaysVal>now)
      }else if(Number.isFinite(wbPct) && wbPct!==100){
        // Active budget. Firmware only echoes back the days count (1-30) in PID 39, not an epoch
        // end-time, so we can't know when the budget started on the controller. We persist the
        // once-computed end-time in localStorage keyed by zone, along with the pct + days that
        // anchored it, so we can detect when the controller restarts the timer (pct or days
        // changed locally or from another client) and reset our countdown accordingly.
        let days=Math.min(30, Math.max(0, Math.round(wbDaysVal)))
        let stored=null
        try{
          let raw=localStorage.getItem(`wbEndTime:${zoneIdKey}`)
          if(raw){
            let parsed=JSON.parse(raw)
            if(parsed && typeof parsed==="object"){stored=parsed}
          }
        }catch(e){}
        let restart=(!stored
          || stored.p!==wbPct
          || stored.d!==days
          || !(stored.e>now))
        let endTime
        if(restart){
          // Controller (re)started the timer — pct or days differs from what we last anchored,
          // or the previous anchor expired. Recompute end-time = now + days*86400 and persist.
          endTime=days>0?(now+days*86400):0
          if(endTime){
            try{localStorage.setItem(`wbEndTime:${zoneIdKey}`,
              JSON.stringify({e:endTime, p:wbPct, d:days}))}catch(e){}
          }
        }else{
          // Same pct + days as before — keep counting down from the saved anchor.
          endTime=stored.e
        }
        nextState.waterBudgetPct=wbPct
        nextState.waterBudgetActive=(endTime>0)
        nextState.waterBudgetEndTime=endTime
      }
    }
    if(isHR16 && !this.state.rainSkipOpen){
      // Rain Skip state reconciliation.
      //
      // Firmware exposes rainSkipOffTime as a 2-element array (see
      //   pearl/shared/Legacy/Inc/Device.h:823
      //   uint32_t rainSkipOffTime[2];  // [0]=duration_secs, [1]=UTC endtime (0=inactive)
      // ):
      //   - rain_skip_time   (PID 40) = configured duration in seconds. STICKY — keeps its
      //                                 last value even after rain skip is cancelled. NOT
      //                                 a reliable "is active" flag.
      //   - rain_skip_time2  (PID 42) = UTC endtime. 0 = inactive. >now = active and ends
      //                                 at this timestamp. THIS is the source of truth.
      //
      // Order:
      //   1. Stopping (cancel in flight) — wait for rsEnd=0 confirmation.
      //   2. Pending  (start in flight)  — hold optimistic banner until rsEnd>now OR 30s.
      //   3. Otherwise, derive everything from rsEnd.
      let rsPid=getParamId2(1900,"pearl_config","rain_skip_time")
      let rsEndPid=getParamId2(1900,"pearl_config","rain_skip_time2")
      let rsVal=+((dbVals.z[zInd]||{})[240]||{})[rsPid]||0
      let rsEnd=+((dbVals.z[zInd]||{})[240]||{})[rsEndPid]||0
      let now=Math.floor(Date.now()/1000)
      let zoneIdKey=this.state.zoneId||(globs.zonesInfo.info[zInd]||{}).zoneId||""
      let isActiveOnCtrl=(rsEnd>now)
      // cl("Rain Skip debug:", {rsVal, rsEnd, now, isActiveOnCtrl,
        // pending:this.state.rainSkipPending, stopping:this.state.rainSkipStopping})
      if(this.state.rainSkipStopping){
        if(!isActiveOnCtrl){
          nextState.rainSkipStopping=false
          nextState.rainSkipPending=false
          nextState.rainSkipPendingSince=0
          nextState.rainSkipActive=false
          nextState.rainSkipEndTime=0
          try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
        }
      }else if(this.state.rainSkipPending){
        let elapsed=this.state.rainSkipPendingSince
          ? Date.now()-this.state.rainSkipPendingSince : 0
        if(isActiveOnCtrl){
          // Controller acknowledged. Use the controller's authoritative endtime
          // (firmware decides the exact value, may differ slightly from optimistic).
          nextState.rainSkipPending=false
          nextState.rainSkipPendingSince=0
          nextState.rainSkipEndTime=rsEnd
          nextState.rainSkipActive=true
          try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
        }else if(elapsed>30000){
          // Timed out without controller acknowledgement. Roll back so the banner
          // doesn't get stuck on while the controller has nothing scheduled.
          nextState.rainSkipActive=false
          nextState.rainSkipEndTime=0
          nextState.rainSkipPending=false
          nextState.rainSkipPendingSince=0
          try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
        }
        // Otherwise: hold the optimistic state untouched (banner stays visible).
      }else if(isActiveOnCtrl){
        // Controller is in rain skip. rsEnd is the authoritative UTC endtime.
        nextState.rainSkipEndTime=rsEnd
        nextState.rainSkipActive=true
        try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
      }else{
        // rsEnd === 0 (or in the past) → inactive, regardless of the sticky duration value.
        nextState.rainSkipActive=false
        nextState.rainSkipEndTime=0
        try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
      }
    }
    this.setState(nextState)
  }

  filterEquipment = (equipment, hideEquipment) => {
//     cl(equipment,hideEquipment)
    const pa = this.props.parms;
    let st=this.state
    let gotEq=equipment.filter(eq=>{return eq.chType!="channel_None"})
//     cl(gotEq)
    // const zInfo = globs.zonesInfo.info[getZoneIndex(pa.zone)];
    let twoChan, firstChan;
    if(pa.gwType==800){
      twoChan=[
        constant.EQ_800_VENT-constant.EQ_800_BASE,
        constant.EQ_800_CURTAIN-constant.EQ_800_BASE
      ];
      firstChan=twoChan;
    }else{
      twoChan=[
        constant.EQ_2ND_VENT, constant.EQ_2ND_CURT, constant.EQ_2ND_MIXV,
        constant.EQ_2ND_MZONE2, constant.EQ_2ND_GEN_PID, constant.EQ_2ND_CRAVO
      ];
      firstChan=[
        constant.EQ_VENT, constant.EQ_CURT, constant.EQ_MIXV, constant.EQ_GEN_PID
      ];
    }
    let chFlagsId=(pa.gwType==1900)?getParamId2(1900,"pearl_chan_anx_stat","eqFlags"):null
    return equipment.filter((e, i) =>{
      if(chFlagsId!==null){
        let raw=dbVals.z[st.zInd]?.[e.chan]?.[chFlagsId]
        let chFlags=(raw!==undefined&&raw!==null)?+raw:0
        if(chFlags&(lc.EQ_FLAGS_OPEN_CIRCUIT|lc.EQ_FLAGS_SHORT)){
          e.alarm=true
        }
      }
      return (
        (i % 2 !== 1) ||
        (twoChan?.includes(+equipment[i].type) && i > 0 && !firstChan?.includes(+equipment[i - 1].type)) ||
        (!twoChan?.includes(+equipment[i].type)) || e.analog
      ) &&
      !(hideEquipment && equipment[i].chType === "channel_None")
    });
  }

  makeEqList = (equipment) => {
    let twoChan = [
      constant.EQ_2ND_VENT, 
      constant.EQ_2ND_CURT, 
      constant.EQ_2ND_MIXV, 
      constant.EQ_2ND_MZONE2, 
      constant.EQ_2ND_GEN_PID, 
      constant.EQ_2ND_CRAVO
    ];
    let equip = [];
    let fullEquip = [];  // New array to store equipment that meets the twoChan condition
    let pa = this.props.parms;
    let zInfo = globs.zonesInfo.info[getZoneIndex(pa.zone)];
  
    equipment.forEach((e, i) => {
      const isTwoChan = twoChan.includes(+equipment[i].type);
      const shouldAddToEquip = 
        ((i % 2 !== 1) || !isTwoChan || e.analog) && 
        !(zInfo?.hideEquipment && equipment[i].chType === "channel_None");
  
      // Object to store equipment data
      let eqObj = {
        chType: e.chType,
        id: e.id,
        name: e.name,
        url: `/usa/c18/fui/${e.chType}/${this.state.zInd}-${e.unit}-${e.chan}-0`,
        type: e.type,
      };
  
      // Add to `equip` if it meets the `shouldAddToEquip` condition and doesn't already exist in `equip`
      if (shouldAddToEquip && !equip.some(item => item.id === e.id)) {
        equip.push(eqObj);
        fullEquip.push(eqObj);
      }
  
      // Add to `fullEquip` if it meets the `isTwoChan` condition and doesn't already exist in `fullEquip`
      if (isTwoChan && !fullEquip.some(item => item.id === e.id)) {
        fullEquip.push(eqObj);
      }
    });
  
    return { equip, fullEquip };
  }
    onClick=(type,e,eq,index)=>{
//     cl(type,eq,index)
// http://stage.c2.link4cloud.com:3114/fui/live/channel_None/0-0-1-0
// http://ngsg.link4cloud.com:3104/usa/c18/fui/unit_Input_Multipliers/0-0-0-0
//     cl(this.state.eqList)
    switch(type){
      case "equip":
        e.preventDefault()
//         cl(eq)
//         cl([eq.id,eq.chType])
//         cl(eq)
        let url=`/usa/c18/fui/${eq.chType}/${this.state.zInd}-${eq.unit}-${eq.chan}-0`
        history.push({
          pathname: url,
        },
        {
          eqList: this.state.eqList
        });
        // history.push(url)
        break
      case "info":// index is the equip array, *not* the id
//         let eqArr=Object.assign({},this.state.equipment)
//         cl(index)
        let eqArr=this.state.equipment.slice(0)
//         cl(eqArr)
//         cl(index)
        eqArr[index].showInfo=!eqArr[index].showInfo
        this.setState({equipment:eqArr})
        break
      default:
        break
    }
  }

  showEquipmentRowDiv=(alarmClass,e,onClass,i,i2)=>{
//     console.log("showEquipmentRowDiv alarmClass, e, onClass, i, i2 ", alarmClass, e, onClass, i, i2)
    let showInfo=(e.showInfo)?" show-details":""
    let selected=(this.state.waterNowChannelId && (+this.state.waterNowChannelId===+e.id))?" equipment-water-now-selected":""
    let isWateringNow=(+e.overrideType===25) ||
      (!!this.state.waterNowPending && e.chan===this.state.waterNowActiveChan)
    let isWalkValve=isConfiguredEquipmentChannel(e) && (
      (+e.overrideType===26) ||
      (!!this.state.walkValvePending && e.chan===this.state.walkValveActiveChan)
    )
    let isAuxOverride=(+e.overrideType===10)
    let wateringNow=(isWateringNow||isWalkValve) ? " equipment-row-active" : (isAuxOverride ? " " : "")
    let override=((+e.reportedPos)!=e.relState)?
      (e.swPos?" forced":""):
      (e.swPos)?" non-auto":" auto"
    if(e.type==constant.EQ_NONE){override=""}
    let mainRow=(
      <div key={i+i2} className={`eq-row${alarmClass?" "+alarmClass:""}${showInfo}${selected}${wateringNow}`}>
        <div className="eq-col-name">
          <C18Anchor00 to="" className="name" translate="no" onClick={(ev)=>
            this.onClick("equip",ev,e)}>
              {`${e.id}. ${(e.name)?e.name:"None"}`}
          </C18Anchor00>
        </div>
        <div className="eq-col-status">
          <C18Anchor00 to="" className={`on-off-indicator${onClass}`} onClick={(ev)=>
            this.onClick("equip",ev,e)}>
            {`${e.system}`}
          </C18Anchor00>
        </div>
        <div className="eq-col-info">
          {this.state.isHR16 ? (
            this.renderInfoCell(e, isWateringNow, isWalkValve, override)
          ) : (
            <div className="eq-info-tip-wrap">
              <C18Button00 type="button" className={`info-button${override}`} aria-label="info"
                onClick={(ev)=>
                  this.onClick("info",ev,e,i2)}>i
              </C18Button00>
              <div className="eq-info-tooltip">
                
                {`${e.status}${([" non-auto", " forced"].includes(override)) ? `, ${e.auto}` : ""}`}
              </div>
            </div>
          )}
        </div>
      </div>
    )
    return mainRow
  }

  showOneEquipment = () => {
    let equip = [];
    this.state.filteredEquipment.forEach((e, i) => {
      let onClass = (["Auto OFF","OFF","None","0%","Force OFF"].includes(e.system)) ? "" : " on";
      let alarmClass = (e.alarm) ? "alarm-on" : "";
      let i2=this.state.filteredEquipment[i].chan
      equip.push(this.showEquipmentRowDiv(alarmClass, e, onClass, i, i2));
    });
    return (
      <div className={`equipment-rows${this.state.isHR16?" hr16":""}`}>
        <div className="eq-row-header">
          <div className="eq-col-name">Name</div>
          <div className="eq-col-status">Status</div>
          {this.state.isHR16 ? (
            <div className="eq-col-info">Info</div>
          ) : (
            <div className="eq-col-info" aria-hidden="true"></div>
          )}
        </div>
        {equip}
      </div>
    );
  }  

  hasWaterNow=()=>{
    if(!this.state.isHR16){return false}
    if(this.state.waterNowPending && this.state.waterNowActiveChan!=null){return true}
    let list=this.state.equipment||[]
    for(let i=0;i<list.length;i++){
      if(list[i] && +list[i].overrideType===25){return true}
    }
    return false
  }
  hasRainSkip=()=>{
    if(!this.state.isHR16){return false}
    let list=this.state.equipment||[]
    for(let i=0;i<list.length;i++){
      if(list[i] && +list[i].overrideType===24){return true}
    }
    return false
  }
  hasWalkValve=()=>{
    if(!this.state.isHR16){return false}
    if(this.state.walkValvePending){return true}
    let list=this.state.equipment||[]
    for(let i=0;i<list.length;i++){
      let e=list[i]
      if(e&&isConfiguredEquipmentChannel(e)&&+e.overrideType===26){return true}
    }
    return false
  }
  /** Count configured stations between sch..ech (Pearl skips None / EQ_NONE); matches firmware walk valve. */
  countWalkValveWateringStations=(equipment, sch, ech)=>{
    let lo=Math.min(+sch||0, +ech||0)
    let hi=Math.max(+sch||0, +ech||0)
    let list=equipment||[]
    let n=0
    for(let c=lo;c<=hi;c++){
      let e=list[c]
      if(!e){continue}
      if(+e.type===+constant.EQ_NONE){continue}
      if(e.chType==="channel_None"){continue}
      n++
    }
    return n
  }
  openWaterNow=()=>{
    this.setState({showWaterNow:true})
  }
  
  closeWaterNow=()=>{
    this.setState({showWaterNow:false, waterNowChannelId:"", waterNowDuration:0})
  }
  
  onWaterNowChannelChange=(e)=>{
    let val=e?.currentTarget?.value
    let newState={waterNowChannelId:(val===""?"":+val)}
    if(val!==""){
      let eq=this.state.filteredEquipment.find(eq=>eq.id===+val)
      if(eq){
        let chData=(dbVals.z[this.state.zInd]||{})[eq.chan]||{}
        let ccd="configuration_channel_data"
        let irrMode=+(chData[getParamId(ccd,"irrigation_mode")])||0
        let dur=0
        if(this.state.isHR16 && irrMode===constant.IRR_SCHEDULED){
          // Irrigation schedule: use duration for the closest enabled next start time (slots 1–6)
          let zone240=(dbVals.z[this.state.zInd]||{})[240]||{}
          let unitTime=+(zone240[getParamId2(1900,"snapshots","currentTime")]||0)
          let nowMins=Math.floor(((unitTime%86400)+86400)%86400/60)
          let slots=[]
          for(let i=1;i<=6;i++){
            let start=+(chData[getParamId2(1900,ccd,"start_time_"+i)]??1440)
            let d=+(chData[getParamId2(1900,ccd,"duration_"+i+"_irr")]||0)
            if(start<1440&&d>0) slots.push({start,dur:d})
          }
          if(slots.length){
            slots.sort((a,b)=>a.start-b.start)
            slots.push({start:slots[0].start+1440,dur:slots[0].dur})
            let next=slots.find(s=>s.start>nowMins)
            if(next) dur=next.dur
            else dur=+(chData[getParamId2(1900,ccd,"duration_1_irr")])||0
          }
          if(!dur) dur=+(chData[getParamId2(1900,ccd,"duration_1_irr")])||0
        }else if(this.state.isHR16 && irrMode===constant.IRR_CYCLE){
          dur=+(chData[getParamId(ccd,"duration_1_irr")]) || +(chData[getParamId(ccd,"off_duration")])||0
        }else if(this.state.isHR16 && (
          irrMode===constant.IRR_SOIL_TRIGGER ||
          irrMode===constant.IRR_ACCUMULATED ||
          irrMode===constant.IRR_VPD
        )){
          dur=+(chData[getParamId(ccd,"duration_1_irr")])||0
        }
        if(!dur){
          dur=+(chData[getParamId(ccd,"on_duration")])||0
        }
        if(dur>0){newState.waterNowDuration=dur}
      }
    }
    this.setState(newState)
  }
  
  onWaterNowDurationChange=({duration})=>{
    let dur=Math.max(0, Math.round(+duration||0))
    this.setState({waterNowDuration:dur})
  }
  
  onWaterNowStop=async()=>{
    let st=this.state
    let zInfo=st.zoneInfo
    let chan=st.waterNowActiveChan
    if(chan==null && (st.equipment||[]).length){
      let eqWithOverride=(st.equipment||[]).find(e=>e&&+e.overrideType===25)
      if(eqWithOverride) chan=eqWithOverride.chan
    }
    if(chan==null) chan=st.filteredEquipment?.find(e=>e.id===+st.waterNowChannelId)?.chan
    if(zInfo&&chan!=null){
      cl("stopDemand: sending command", {gatewayId:zInfo.gatewayId, ch:chan})
      try{
        let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
          sessionId: globs.userData.session.sessionId, body:{
            gatewayId: zInfo.gatewayId,
            cmd:"multiCmd",
            subCmd:"stopDemand",
            ch: chan,
          }})
        cl("stopDemand: response", resp)
      }catch(e){
        cl("stopDemand: error", e)
      }
    }else{
      cl("stopDemand: missing zoneInfo or channel", {zInfo, waterNowActiveChan: st.waterNowActiveChan})
    }
    if(this.state.waterNowPendingTO){clearTimeout(this.state.waterNowPendingTO)}
    this.setState({waterNowActiveChan:null, waterNowPending:false, waterNowPendingTO:null})
    this.closeWaterNow()
  }
  
  sendWaterNow=async()=>{
    let st=this.state
    let zInfo=st.zoneInfo
    let eq=st.filteredEquipment.find(e=>e.id===+st.waterNowChannelId)
    if(!zInfo||!eq){
      cl("waterNow: missing zoneInfo or equipment", {zInfo, channelId: st.waterNowChannelId})
      this.closeWaterNow()
      return
    }
    let dur=Math.max(0, Math.round(+st.waterNowDuration||0))
    let chan=eq.chan
    cl("waterNow: sending command", {gatewayId:zInfo.gatewayId, ch:chan, dur})
    if(this.state.waterNowPendingTO){clearTimeout(this.state.waterNowPendingTO)}
    let waterNowPendingTO=setTimeout(()=>{
      this.setState(s=>{
        if(!s.waterNowPending){return {waterNowPendingTO:null}}
        let hasOverride=(s.equipment||[]).some(e=>e&&+e.overrideType===25)
        if(hasOverride){
          return {waterNowPending:false, waterNowPendingTO:null}
        }
        return {waterNowPending:false, waterNowPendingTO:null, waterNowActiveChan:null}
      })
    }, dur*1000)
    this.setState({
      showWaterNow:false,
      waterNowChannelId:"",
      waterNowDuration:0,
      waterNowActiveChan:chan,
      waterNowPending:true,
      waterNowPendingTO,
    })
    try{
      let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
        sessionId: globs.userData.session.sessionId, body:{
          gatewayId: zInfo.gatewayId,
          cmd:"multiCmd",
          subCmd:"waterNOW",
          ch: chan,
          dur: dur,
        }})
      cl("waterNow: response", resp)
      let cmd=((resp||{}).data||{}).res?.cmd
      if((cmd==null) && (((resp||{}).data||{}).res||{}).res){
        cmd=(((resp||{}).data||{}).res||{}).res?.cmd
      }
      if(+cmd===-1){
        if(this.state.waterNowPendingTO){clearTimeout(this.state.waterNowPendingTO)}
        this.setState({waterNowPending:false, waterNowActiveChan:null, waterNowPendingTO:null})
      }
    }catch(e){
      cl("waterNow: error", e)
      if(this.state.waterNowPendingTO){clearTimeout(this.state.waterNowPendingTO)}
      this.setState({waterNowPending:false, waterNowActiveChan:null, waterNowPendingTO:null})
    }
  }
  
  openRainSkipPopup=()=>{
    this.setState({rainSkipOpen:true})
  }

  closeRainSkipPopup=()=>{
    this.setState({rainSkipOpen:false})
  }

  onRainSkipValueChange=(e)=>{
    let val=Math.max(1, Math.round(+e.currentTarget.value||1))
    let max=(this.state.rainSkipUnit==="days")?30 : (this.state.rainSkipUnit==="hours")?720 : 43200
    val=Math.min(max, val)
    this.setState({rainSkipValue:val})
  }

  onRainSkipUnitChange=(e)=>{
    let unit=e.currentTarget.value
    let val=this.state.rainSkipValue
    let max=(unit==="days")?30 : (unit==="hours")?720 : 43200
    if(val>max){val=max}
    this.setState({rainSkipUnit:unit, rainSkipValue:val})
  }

  getRainSkipSeconds=()=>{
    let v=this.state.rainSkipValue
    let u=this.state.rainSkipUnit
    if(u==="days")return v*86400
    if(u==="hours")return v*3600
    return v*60
  }

  sendRainSkipStart=async()=>{
    let zInfo=this.state.zoneInfo
    if(!zInfo){
      cl("rainSkip: missing zoneInfo")
      this.closeRainSkipPopup()
      return
    }
    let secs=this.getRainSkipSeconds()
    let zInd=zInfo.siteZoneIndex
    let controllerId=zInfo?.controllerId
    let rainSkipPid=getParamId2(1900,"pearl_config","rain_skip_time")
    let now=Math.floor(Date.now()/1000)
    let endTime=now+secs
    let zoneIdKey=this.state.zoneId||zInfo.zoneId||""
    cl("rainSkip: sending duration then start", {gatewayId:zInfo.gatewayId, secs})
    // Set optimistic state BEFORE the network call so the banner appears immediately.
    // Polling will reconcile from rsEnd (PID 42) once the controller echoes back, or
    // roll back via the 30s pending timeout if the controller never acknowledges.
    // Also clear any legacy localStorage anchor — controller's rsEnd is the truth.
    try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
    this.setState({
      rainSkipOpen:false,
      rainSkipActive:true,
      rainSkipEndTime:endTime,
      rainSkipPending:true,
      rainSkipPendingSince:Date.now(),
    })
    try{
      let arr=[{z:zInd, c:240, f:2, i:rainSkipPid, t:now, d:String(secs)}]
      await sendArray(arr,false,1900,controllerId,false)
      let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
        sessionId: globs.userData.session.sessionId, body:{
          gatewayId: zInfo.gatewayId,
          cmd:"multiCmd",
          subCmd:"rainSkip",
          cond: 1,
        }})
      cl("rainSkip start: response", resp)
      // Only treat an explicit cmd=-1 (controller-reported failure) as a rollback.
      // Other transient response shapes are NOT errors — the controller may still
      // have applied the change. Polling will validate via rsVal.
      let cmd=((resp||{}).data||{}).res?.cmd
      if((cmd==null) && (((resp||{}).data||{}).res||{}).res){
        cmd=(((resp||{}).data||{}).res||{}).res?.cmd
      }
      if(+cmd===-1){
        cl("rainSkip start: controller reported failure, rolling back")
        try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
        this.setState({
          rainSkipActive:false,
          rainSkipEndTime:0,
          rainSkipPending:false,
          rainSkipPendingSince:0,
        })
      }
    }catch(e){
      // Network/RPC error — don't eagerly roll back. The controller may have received
      // the command anyway. Polling will either confirm via rsVal>0 (clears pending)
      // or time out the optimistic state after 30s.
      // cl("rainSkip start: error (keeping optimistic state, polling will reconcile)", e)
    }
  }

  sendRainSkipStop=async()=>{
    let zInfo=this.state.zoneInfo
    if(!zInfo){
      cl("rainSkip: missing zoneInfo")
      this.closeRainSkipPopup()
      return
    }
    cl("rainSkip: sending stop", {gatewayId:zInfo.gatewayId})
    this.closeRainSkipPopup()
    let zoneIdKey=this.state.zoneId||zInfo.zoneId||""
    try{localStorage.removeItem(`rsEndTime:${zoneIdKey}`)}catch(e){}
    // Optimistically hide the banner immediately; rainSkipStopping keeps it hidden
    // until the controller confirms by setting rsVal back to 0.
    this.setState({rainSkipActive:false, rainSkipEndTime:0, rainSkipStopping:true, rainSkipPending:false})
    try{
      let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
        sessionId: globs.userData.session.sessionId, body:{
          gatewayId: zInfo.gatewayId,
          cmd:"multiCmd",
          subCmd:"rainSkip",
          cond: 0,
        }})
      cl("rainSkip stop: response", resp)
    }catch(e){
      cl("rainSkip stop: error", e)
      this.setState({rainSkipStopping:false})
    }
  }

  sendRainSkipSave=async()=>{
    // Treat "already active" as either the channel reporting overrideType=24 OR the
    // cloud having an in-flight optimistic activation (rainSkipActive). This avoids
    // sending a redundant cond:1 start when the user just adjusts duration.
    let isActive=(this.hasRainSkip()||this.state.rainSkipActive) && !this.state.rainSkipStopping
    if(isActive){
      let zInfo=this.state.zoneInfo
      if(!zInfo){return}
      let secs=this.getRainSkipSeconds()
      let zInd=zInfo.siteZoneIndex
      let controllerId=zInfo?.controllerId
      let rainSkipPid=getParamId2(1900,"pearl_config","rain_skip_time")
      let now=Math.floor(Date.now()/1000)
      cl("rainSkip: saving duration while active", {secs})
      this.closeRainSkipPopup()
      try{
        let arr=[{z:zInd, c:240, f:2, i:rainSkipPid, t:now, d:String(secs)}]
        await sendArray(arr,false,1900,controllerId,false)
      }catch(e){cl("rainSkip save duration: error", e)}
    }else{
      this.sendRainSkipStart()
    }
  }

  openWalkValve=()=>{
    this.setState({showWalkValve:true})
  }

  closeWalkValve=()=>{
    this.setState({showWalkValve:false, walkValveStartCh:"", walkValveEndCh:"", walkValveDuration:15})
  }

  onWalkValveStartChange=(e)=>{
    let val=e?.currentTarget?.value
    this.setState({walkValveStartCh:(val===""?"":+val)})
  }

  onWalkValveEndChange=(e)=>{
    let val=e?.currentTarget?.value
    this.setState({walkValveEndCh:(val===""?"":+val)})
  }

  onWalkValveDurationChange=({duration})=>{
    let dur=Math.max(0, Math.round(+duration||0))
    this.setState({walkValveDuration:dur})
  }

  sendWalkValve=async()=>{
    let st=this.state
    let zInfo=st.zoneInfo
    let startEq=st.filteredEquipment.find(e=>e.id===+st.walkValveStartCh)
    let endEq=st.filteredEquipment.find(e=>e.id===+st.walkValveEndCh)
    if(!zInfo||!startEq||!endEq){
      cl("walkValve: missing zoneInfo or equipment", {zInfo, startCh:st.walkValveStartCh, endCh:st.walkValveEndCh})
      this.closeWalkValve()
      return
    }
    let dur=Math.max(0, Math.round(+st.walkValveDuration||0))
    let sch=startEq.chan
    let ech=endEq.chan
    let stationCount=this.countWalkValveWateringStations(st.equipment, sch, ech)
    if(stationCount<=0){
      cl("walkValve: no watering stations in range (all NONE?)", {sch, ech})
      this.closeWalkValve()
      return
    }
    if(this.state.walkValvePendingTO){clearTimeout(this.state.walkValvePendingTO)}
    // Firmware waters only configured stations; do not count None slots between sch..ech.
    let totalDur=stationCount*dur
    let walkValvePendingTO=setTimeout(()=>{
      this.setState(s=>{
        if(!s.walkValvePending){return {walkValvePendingTO:null}}
        let hasOverride=(s.equipment||[]).some(
          e=>e&&isConfiguredEquipmentChannel(e)&&+e.overrideType===26
        )
        if(hasOverride){
          return {walkValvePending:false, walkValvePendingTO:null}
        }
        return {walkValvePending:false, walkValvePendingTO:null, walkValveActiveChan:null}
      })
    }, totalDur*1000)
    this.setState({
      showWalkValve:false,
      walkValveStartCh:"",
      walkValveEndCh:"",
      walkValveDuration:15,
      walkValvePending:true,
      walkValveActiveChan:sch,
      walkValvePendingTO,
    })
    try{
      let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
        sessionId: globs.userData.session.sessionId, body:{
          gatewayId: zInfo.gatewayId,
          cmd:"multiCmd",
          subCmd:"walkValve",
          sch: sch,
          ech: ech,
          dur: dur,
        }})
      cl("walkValve: response", resp)
      let cmd=((resp||{}).data||{}).res?.cmd
      if((cmd==null) && (((resp||{}).data||{}).res||{}).res){
        cmd=(((resp||{}).data||{}).res||{}).res?.cmd
      }
      if(+cmd===-1){
        if(this.state.walkValvePendingTO){clearTimeout(this.state.walkValvePendingTO)}
        this.setState({walkValvePending:false, walkValveActiveChan:null, walkValvePendingTO:null})
      }
    }catch(e){
      cl("walkValve: error", e)
      if(this.state.walkValvePendingTO){clearTimeout(this.state.walkValvePendingTO)}
      this.setState({walkValvePending:false, walkValveActiveChan:null, walkValvePendingTO:null})
    }
  }

  onWalkValveStop=async()=>{
    let st=this.state
    let zInfo=st.zoneInfo
    if(!zInfo){
      cl("walkValve stop: missing zoneInfo")
      return
    }
    cl("walkValve stop: sending command", {gatewayId:zInfo.gatewayId})
    try{
      let resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
        sessionId: globs.userData.session.sessionId, body:{
          gatewayId: zInfo.gatewayId,
          cmd:"multiCmd",
          subCmd:"stopDemand",
        }})
      cl("walkValve stop: response", resp)
    }catch(e){
      cl("walkValve stop: error", e)
    }
    if(this.state.walkValvePendingTO){clearTimeout(this.state.walkValvePendingTO)}
    this.setState({walkValveActiveChan:null, walkValvePending:false, walkValvePendingTO:null})
  }

  openWaterBudget=()=>{
    this.setState({waterBudgetOpen:true})
  }

  closeWaterBudget=()=>{
    this.setState({waterBudgetOpen:false})
  }

  onWaterBudgetPctChange=(e)=>{
    let val=Math.min(300, Math.max(0, Math.round(+e.currentTarget.value||0)))
    this.setState({waterBudgetPct:val})
  }

  onWaterBudgetDaysChange=(e)=>{
    let val=Math.min(30, Math.max(1, Math.round(+e.currentTarget.value||1)))
    this.setState({waterBudgetDays:val})
  }

  sendWaterBudget=async()=>{
    let zInfo=this.state.zoneInfo
    if(!zInfo){
      cl("waterBudget: missing zoneInfo")
      this.closeWaterBudget()
      return
    }
    let pct=this.state.waterBudgetPct
    let days=this.state.waterBudgetDays
    let now=Math.floor(Date.now()/1000)
    let zInd=zInfo.siteZoneIndex
    let controllerId=zInfo?.controllerId
    let pctPid=getParamId2(1900,"pearl_config","water_budget_pct")
    let daysPid=getParamId2(1900,"pearl_config","water_budget_days")
    cl("waterBudget: sending", {zInd, pct, days, pctPid, daysPid})
    this.closeWaterBudget()
    let zoneIdKey=this.state.zoneId||(globs.zonesInfo.info[zInd]||{}).zoneId||""
    if(pct!==100){
      let endTime=now+(days*86400)
      // Persist {endTime, pct, days} so getEquipment can detect a future pct/days change from
      // the controller and restart the timer to match.
      try{localStorage.setItem(`wbEndTime:${zoneIdKey}`,
        JSON.stringify({e:endTime, p:pct, d:days}))}catch(e){}
      this.setState({
        waterBudgetActive:true,
        waterBudgetPct:pct,
        waterBudgetEndTime:endTime,
      })
    }else{
      try{localStorage.removeItem(`wbEndTime:${zoneIdKey}`)}catch(e){}
      this.setState({waterBudgetActive:false, waterBudgetEndTime:0, waterBudgetPct:100})
    }
    try{
      let arr=[
        {z:zInd, c:240, f:2, i:pctPid, t:now, d:String(pct)},
        {z:zInd, c:240, f:2, i:daysPid, t:now, d:String(days)},
      ]
      await sendArray(arr,false,1900,controllerId,false)
      // cl("waterBudget: sent", arr)
    }catch(e){
      cl("waterBudget: error", e)
    }
  }

  cancelWaterBudget=async()=>{
    let zInfo=this.state.zoneInfo
    if(!zInfo){return}
    let now=Math.floor(Date.now()/1000)
    let zInd=zInfo.siteZoneIndex
    let controllerId=zInfo?.controllerId
    let pctPid=getParamId2(1900,"pearl_config","water_budget_pct")
    let daysPid=getParamId2(1900,"pearl_config","water_budget_days")
    cl("waterBudget: cancelling", {zInd})
    // this.setState({waterBudgetActive:false, waterBudgetEndTime:0, waterBudgetPct:100})
    try{
      let arr=[
        {z:zInd, c:240, f:2, i:pctPid, t:now, d:"100"},
        {z:zInd, c:240, f:2, i:daysPid, t:now, d:"7"},
      ]
      await sendArray(arr,false,1900,controllerId,false)
      let zoneIdKey=this.state.zoneId||(globs.zonesInfo.info[zInd]||{}).zoneId||""
      try{localStorage.removeItem(`wbEndTime:${zoneIdKey}`)}catch(e){}
      this.setState({waterBudgetActive:false, waterBudgetEndTime:0, waterBudgetPct:100})
    }catch(e){
      cl("waterBudget cancel: error", e)
    }
  }

  isWaterBudgetActive=()=>{
    if(!this.state.waterBudgetActive){return false}
    if(this.state.waterBudgetEndTime && Math.floor(Date.now()/1000)>=this.state.waterBudgetEndTime){
      return false
    }
    return true
  }

  // Detect whether AUX is currently driving water budget on the controller and, if so,
  // resolve the percent it's setting. Returns {active, pct}.
  //
  // Active state is taken directly from pearl_aux_status.wb_pct_stat bit0 — if firmware
  // says AUX is driving water budget, we trust it and show the banner regardless of
  // percentage (including 0% and 100%).
  //
  // Percent is resolved from the first available source:
  //   1. pearl_aux_status.wb_pct_set       — runtime mirror (FW not writing yet, 2026-05)
  //   2. snapshot_aux_variables[+19]       — legacy slot (older firmware)
  //   3. config_aux_controls walk          — fallback. Match the AUX program row that's
  //                                          configured to "set Water Budget" (action=0,
  //                                          targetType=23) and read its actionParameter.
  //                                          Only used when exactly one such rule exists.
  detectAuxWaterBudget=(zInd)=>{
    let zone240=(dbVals.z[zInd]||{})[240]||{}
    let wbStatPid=getParamId2(1900,"pearl_aux_status","wb_pct_stat")
    let statFlag=((+zone240[wbStatPid]||0) & 1)===1
    if(!statFlag){return {active:false, pct:0}}
    let wbSetPid=getParamId2(1900,"pearl_aux_status","wb_pct_set")
    let auxVarBase=getParamId2(1900,"snapshot_aux_variables","variableValue")
    let pct=(+zone240[wbSetPid]||0) || (+zone240[auxVarBase+19]||0) || 0
    if(!pct){
      const ACTION_SET=0
      const TARGET_WATER_BUDGET_PCT=23
      const STRIDE=17
      let actionPidBase=getParamId2(1900,"config_aux_controls","action")
      let targetTypePidBase=getParamId2(1900,"config_aux_controls","targetType")
      let actionParamPidBase=getParamId2(1900,"config_aux_controls","actionParameter")
      let configMatches=0
      let onlyMatch=0
      for(let row=0;row<128;row++){
        let off=row*STRIDE
        if((+zone240[actionPidBase+off]||0)===ACTION_SET &&
           (+zone240[targetTypePidBase+off]||0)===TARGET_WATER_BUDGET_PCT){
          configMatches++
          if(configMatches===1){onlyMatch=+zone240[actionParamPidBase+off]||0}
          if(configMatches>1){break}
        }
      }
      if(configMatches===1){pct=onlyMatch}
    }
    return {active:true, pct}
  }

  renderWaterNowActions=()=>{
    if(!this.state.isHR16){return null}
    return(
      <div className="water-now-actions action-water-now">
        <C18Button00 type="button" className="water-now-button"
          id="water-now-button"
          onClick={this.openWaterNow}
          disabled={this.hasWaterNow()}>
          <span className="material-icons-outlined action-btn-icon" translate="no">opacity</span>
          <span className="water-now-text">Water Now</span>
        </C18Button00>
        {this.hasWaterNow() && (
          <C18Button00 type="button" className="water-now-stop"
            onClick={this.onWaterNowStop}
            title="Stop Water Now"
            aria-label="Stop water now">
            <span style={{color: "red"}} className="material-icons-outlined" translate="no">close</span>
          </C18Button00>
        )}
      </div>
    )
  }
  renderRainSkipActions=()=>{
    if(!this.state.isHR16){return null}
    let isActive=(this.hasRainSkip()||this.state.rainSkipActive) && !this.state.rainSkipStopping
    return(
      <div className="water-now-actions action-rain-skip">
        <C18Button00 type="button" className={`water-now-button${isActive?" rain-skip-active":""}`}
          onClick={this.openRainSkipPopup} id="rain-skip-button">
          <span className="material-icons-outlined material-symbols-outlined action-btn-icon" translate="no">rainy</span>
          <span className="water-now-text">Rain Skip</span>
        </C18Button00>
        {isActive && (
          <C18Button00 type="button" className="water-now-stop"
            onClick={this.sendRainSkipStop}
            title="Stop Rain Skip"
            aria-label="Stop rain skip">
            <span style={{color: "red"}} className="material-icons-outlined" translate="no">close</span>
          </C18Button00>
        )}
      </div>
    )
  }
  isRainSkipActive=()=>{
    return this.state.isHR16 && (this.hasRainSkip()||this.state.rainSkipActive) && !this.state.rainSkipStopping
  }

  renderRainSkipStatusBar=()=>{
    if(!this.state.isHR16){return null}
    if(!this.isRainSkipActive() || !this.state.rainSkipEndTime) return null
    return(
      <C18HydroRootStatusBar
        className="rain-skip-status-bar"
        label="Rain Skip"
        endTime={this.state.rainSkipEndTime}
        onCancel={this.sendRainSkipStop}
      />
    )
  }
  renderWalkValveActions=()=>{
    if(!this.state.isHR16){return null}
    let isActive=this.hasWalkValve()
    return(
      <div className="water-now-actions action-walk-valve">
        <C18Button00 type="button" className="water-now-button"
          onClick={this.openWalkValve}
          id="walk-valve-button"
          disabled={isActive}>
          <span className="material-icons-outlined action-btn-icon" translate="no">directions_walk</span>
          <span className="water-now-text">Walk Valve</span>
        </C18Button00>
        {isActive && (
          <C18Button00 type="button" className="water-now-stop"
            onClick={this.onWalkValveStop}
            title="Stop Walk Valve"
            aria-label="Stop walk valve">
            <span style={{color: "red"}} className="material-icons-outlined" translate="no">close</span>
          </C18Button00>
        )}
      </div>
    )
  }

  renderWaterNowPopup=()=>{
    let st=this.state
    if(!st.showWaterNow){return null}
    let canWaterNow=!!st.waterNowChannelId && (+st.waterNowDuration>0)
    let options=st.filteredEquipment
      .filter(e=>e && +e.type!==+constant.EQ_NONE)
      .map(e=>(
      <option key={e.id} value={e.id}>{`${e.id}. ${e.name||"None"}`}</option>
    ))
    return(
      <>
        <div className="popup water-now-popup" style={{display:"block"}}>
          <div className="water-now-header">
            <div className="water-now-title">Water Now</div>
          </div>
          <div className="water-now-field">
            <label>Channel</label>
            <select value={st.waterNowChannelId} onChange={this.onWaterNowChannelChange}>
              <option value="">Select a channel</option>
              {options}
            </select>
          </div>
          <div className="water-now-field">
            <label>Duration</label>
            <C18Duration00
              parms={{
                duration: st.waterNowDuration,
                unit: "(HH:MM:SS)",
                onChange: this.onWaterNowDurationChange,
                saveOK: true,
                width: 140,
                className: "water-now-units"
              }}
            />
          </div>
          <div className="water-now-popup-actions">
            <C18Button00 type="button" className="outlined"
              onClick={this.closeWaterNow}>Close</C18Button00>
            <C18Button00 type="button" className="filled water-now-submit"
              disabled={!canWaterNow}
              onClick={this.sendWaterNow}>Water Now</C18Button00>
          </div>
        </div>
        <div className="popup-scrim" style={{display:"block"}} onClick={this.closeWaterNow}></div>
      </>
    )
  }
  
  renderRainSkipPopup=()=>{
    if(!this.state.rainSkipOpen){return null}
    let st=this.state
    let isActive=this.hasRainSkip()
    let maxVal=(st.rainSkipUnit==="days")?30 : (st.rainSkipUnit==="hours")?720 : 43200
    let canSave=(st.rainSkipValue>=1 && st.rainSkipValue<=maxVal)
    return(
      <>
        <div className="popup water-now-popup" style={{display:"block"}}>
          <div className="water-now-header">
            <div className="water-now-title">Rain Skip</div>
          </div>
          <div className="water-now-field">
            <label>Duration</label>
            <input type="number" min={1} max={maxVal} step={1}
              className="water-now-popup-days"
              value={st.rainSkipValue}
              onChange={this.onRainSkipValueChange}
            />
            <select className="water-now-popup-unit" value={st.rainSkipUnit} onChange={this.onRainSkipUnitChange}>
              <option value="days">Days</option>
              <option value="hours">Hours</option>
              <option value="mins">Mins</option>
            </select>
          </div>
          {isActive && (
            <div className="water-now-field" style={{fontSize:12,color:"#666"}}>
              Rain skip is active. Save updates duration for next run.
            </div>
          )}
          <div className="water-now-popup-actions">
            <C18Button00 type="button" className="outlined"
              onClick={this.closeRainSkipPopup}>Close</C18Button00>
            <C18Button00 type="button" className="filled water-now-submit"
              disabled={!canSave}
              onClick={this.sendRainSkipSave}>Save</C18Button00>
          </div>
        </div>
        <div className="popup-scrim" style={{display:"block"}} onClick={this.closeRainSkipPopup}></div>
      </>
    )
  }

  renderWalkValvePopup=()=>{
    let st=this.state
    if(!st.showWalkValve){return null}
    let options=st.filteredEquipment
      .filter(e=>e && +e.type!==+constant.EQ_NONE)
      .map(e=>(
      <option key={e.id} value={e.id}>{`${e.id}. ${e.name||"None"}`}</option>
    ))
    let startChan=st.walkValveStartCh!==""?+st.walkValveStartCh:null
    let endChan=st.walkValveEndCh!==""?+st.walkValveEndCh:null
    let validRange=startChan!=null && endChan!=null && startChan<endChan
    let canSave=validRange && (+st.walkValveDuration>0)
    return(
      <>
        <div className="popup water-now-popup" style={{display:"block"}}>
          <div className="water-now-header">
            <div className="water-now-title">Walk Valve</div>
          </div>
          <div className="water-now-field">
            <label>Start Station</label>
            <select value={st.walkValveStartCh} onChange={this.onWalkValveStartChange}>
              <option value="">Select start station</option>
              {options}
            </select>
          </div>
          <div className="water-now-field">
            <label>End Station</label>
            <select value={st.walkValveEndCh} onChange={this.onWalkValveEndChange}>
              <option value="">Select end station</option>
              {options}
            </select>
          </div>
          {startChan!=null && endChan!=null && startChan>=endChan && (
            <div className="water-now-field" style={{color:"red",fontSize:12}}>
              End station must be after start station
            </div>
          )}
          <div className="water-now-field">
            <label>Run Time per Station</label>
            <C18Duration00
              parms={{
                duration: st.walkValveDuration,
                unit: "(MM:SS)",     
                pattern: "[0-9]{1,2}:[0-9]{2}",  
                minutes: true,
                onChange: this.onWalkValveDurationChange,
                saveOK: true,
                width: 140,
                className: "water-now-units"
              }}
            />
          </div>
          <div className="water-now-popup-actions">
            <C18Button00 type="button" className="outlined"
              onClick={this.closeWalkValve}>Close</C18Button00>
            <C18Button00 type="button" className="filled water-now-submit"
              disabled={!canSave}
              onClick={this.sendWalkValve}>Save</C18Button00>
          </div>
        </div>
        <div className="popup-scrim" style={{display:"block"}} onClick={this.closeWalkValve}></div>
      </>
    )
  }

  renderWaterBudgetActions=()=>{
    if(!this.state.isHR16){return null}
    let auxActive=this.state.auxWbActive
    return(
      <div className="water-now-actions action-water-budget">
        <C18Button00 type="button" className="water-now-button"
          onClick={this.openWaterBudget} id="water-budget-button"
          disabled={auxActive}
          title={auxActive?"AUX is currently controlling water budget":undefined}>
          <span className="material-icons-outlined action-btn-icon" translate="no">receipt_long</span>
          <span className="water-now-text">Water Budget</span>
        </C18Button00>
      </div>
    )
  }

  renderWaterBudgetStatusBar=()=>{
    if(!this.state.isHR16){return null}
    let rainSkipActive=(this.hasRainSkip()||this.state.rainSkipActive) && !this.state.rainSkipStopping
    if(rainSkipActive) return null
    let isActive=this.isWaterBudgetActive()
    if(!isActive) return null
    // cl("renderWaterBudgetStatusBar: active with endTime", this.state)
    return(
      <C18HydroRootStatusBar
        className="water-budget-status-bar-styled"
        label="Water Budget"
        detail={`${this.state.waterBudgetPct}%`}
        endTime={this.state.waterBudgetEndTime}
        onCancel={this.cancelWaterBudget}
      />
    )
  }

  // Separate banner for AUX-driven water budget so it never suppresses the regular
  // Water Budget banner (which has its own countdown + cancel).
  renderAuxWaterBudgetStatusBar=()=>{
    if(!this.state.isHR16){return null}
    if(!this.state.auxWbActive){return null}
    let rainSkipActive=(this.hasRainSkip()||this.state.rainSkipActive) && !this.state.rainSkipStopping
    if(rainSkipActive) return null
    return(
      <C18HydroRootStatusBar
        className="water-budget-status-bar-styled"
        label="AUX Water Budget"
        detail={`${this.state.auxWbPct}%`}
      />
    )
  }

  

  renderWaterBudgetPopup=()=>{
    if(!this.state.waterBudgetOpen){return null}
    let st=this.state
    let canSave=(st.waterBudgetPct>=0 && st.waterBudgetPct<=300 && st.waterBudgetDays>=1 && st.waterBudgetDays<=30)
    return(
      <>
        <div className="popup water-now-popup" style={{display:"block"}}>
          <div className="water-now-header">
            <div className="water-now-title">Water Budget</div>
          </div>
          <div className="water-now-field">
            <label>Water Budget (0–300%)</label>
            <input type="number" min={0} max={300} step={1} className="input-50"
              value={st.waterBudgetPct}
              onChange={this.onWaterBudgetPctChange}
            />
            <span className="water-budget-hint">100% = normal run time</span>
          </div>
          <div className="water-now-field">
            <label>Duration (days)</label>
            <input type="number" min={1} max={30} step={1}
              className="water-now-popup-days"
              value={st.waterBudgetDays}
              onChange={this.onWaterBudgetDaysChange}
            />
          </div>
          <div className="water-now-popup-actions">
            <C18Button00 type="button" className="outlined"
              onClick={this.closeWaterBudget}>Close</C18Button00>
            <C18Button00 type="button" className="filled water-now-submit"
              disabled={!canSave}
              onClick={this.sendWaterBudget}>Save</C18Button00>
          </div>
        </div>
        <div className="popup-scrim" style={{display:"block"}} onClick={this.closeWaterBudget}></div>
      </>
    )
  }

  showEquipmentOneColumn=()=>{
//     cl(this.state)
//     cl(globs.usersInfo.groupInfo)
//     let hideGroup=(acctFeature("zoneGroups")&&globs.userData.session.groupId&&
//       !globs.usersInfo.groupInfo?.allowSelectZone)?(
//       <div id="zone_group_equipment" style={{position:"absolute",left:0,top:0,width:"100%",
//         height:"100%",borderRadius:10,backgroundColor:"#00CC88",opacity:0.2,cursor:"pointer"}}
//         onClick={e=>this.props.parms.onChange({cmd:"equipmentWrench", val:{wrenchCmd:"wrench"}})}
//         />
//     ):null
//         {hideGroup}
    return (
      <section
        id="equipments1800"
         className={`link4 right-half ${this.state.isHR16 ? "hr16-right" : ""}`}
        style={{ position: 'relative' }}
      >
        <div className="equipment-header-row" >
          <C18DateFormat00
            parms={{
              leftString: 'Equipment',
              leftClass: 'title',
              type: 'wrench',
              ariaLabel: 'equipment settings',
              isHR16: this.state.isHR16,
              onChange: (val) =>
                this.props.parms.onChange({ cmd: 'equipmentWrench', val: val }),
              value: this.state.hideEquipment,
              onToggle: async () => {
                let he = !this.state.hideEquipment;
                let data = {
                  zoneId: this.state.zoneId,
                  hideEquipment: he,
                };
  //               cl(this.state.equipment)
                let filteredEquipment = this.filterEquipment(this.state.equipment, he);
                this.setState({hideEquipment: he, filteredEquipment})
                await wsTrans("usa", {
                  cmd: "cRest",
                  uri: "/s/zones",
                  method: "update",
                  sessionId: globs.userData.session.sessionId,
                  body: data,
                });
              },
            }}
          />    
        </div>
        <div className="zone-actions-bar">
          {this.renderWaterNowActions()}
          {this.renderWaterBudgetActions()}
          {this.state.isHR16 && this.state.actionsExpanded && (
            <>
              {this.renderRainSkipActions()}
              {this.renderWalkValveActions()}
            </>
          )}
          {this.state.isHR16 && (
            <button
              type="button"
              className="actions-toggle-btn"
              onClick={() => this.setState(s => ({ actionsExpanded: !s.actionsExpanded }))}
              aria-label={this.state.actionsExpanded ? "Hide Rain Skip and Walk Valve" : "Show Rain Skip and Walk Valve"}
              title={this.state.actionsExpanded ? "Show less" : "Show more"}
            >
              {this.state.actionsExpanded ? "−" : "+"}
            </button>
          )}
        </div>
       
        {this.renderWaterBudgetStatusBar()}
        {this.renderAuxWaterBudgetStatusBar()}
        {this.renderRainSkipStatusBar()}
        <div className={`equipment-list ${this.state.isHR16 ? "hr16" : ""}${this.isRainSkipActive() ? " rain-skip-grayed" : ""}`} translate='no'>{this.showOneEquipment()}</div>
          {this.renderWaterNowPopup()}
          {this.renderRainSkipPopup()}
          {this.renderWalkValvePopup()}
          {this.renderWaterBudgetPopup()}
      </section>
    );
  }
  
  getAccumulatedIrrigationInfoBoxId=(e)=>{
    const z = this.state.zoneInfo
    if (!z?.gatewayId) return "run-countdown-value-boxes"
    const gwId = z.gatewayId
    const eligible = isHydroR(gwId) || isHydroRoot16(z.zoneId) || isPearlFwAtLeast(gwId, [1, 18, 2])
    if (!eligible) return "run-countdown-value-boxes"
    const ct = e.chType
    if (ct === "channel_Irrigation_Accumulated_Light" || ct === "channel_Irrigation_Accumulated_Light_1900") return "equipment-accumulated-light-hr16"
    if (ct === "channel_Irrigation_VPD" || ct === "channel_Irrigation_VPD_1900") return "equipment-accumulated-vpd-hr16"
    if (ct === "channel_Irrigation_Soil_Trigger" || ct === "channel_Irrigation_Soil_Trigger_1900") return "equipment-accumulated-soil-hr16"
    return "run-countdown-value-boxes"
  }

  renderInfoCell=(e, isWateringNow, isWalkValve, override)=>{
    let rainSkip=this.isRainSkipActive()
    let isAux=(+e.overrideType===10)
    if(isWateringNow){
      return(
        <span className="pill pill-heartbeat-outlined">
          Water-Now
        </span>
      )
    }
    if(isWalkValve){
      return(
        <span className='pill pill-heartbeat-outlined'>
          Walk-Valve
        </span>
      )
    }
    if(isAux){
      return(
        <span className="pill pill-aux-override">
          {`${e.status??"Aux Control Override"}${([" non-auto", " forced"].includes(override)) ? `, ${e.auto}` : ""}`}
        </span>
      )
    }
    if(e.infoText == null){
      return null
    }
    if(e.infoText && e.infoText.type === "scheduledInRun"){
      if(rainSkip) return null
      return(
        <div className="hr16-countdown-single-wrap">
          {e.infoText.runs != null &&
            <div className="hr16-countdown-runs">
              <div className="hr16-countdown-runs-count">{e.infoText.runs}</div>
              <div className="hr16-countdown-runs-label">runs</div>
            </div>
          }
        </div>
      )
    }
    if(e.infoText && e.infoText.type === "scheduledDone"){
      if(rainSkip) return null
      return(
        <div className="hr16-countdown-single-wrap">
          {e.infoText.runs != null &&
            <div className="hr16-countdown-runs">
              <div className="hr16-countdown-runs-count">{e.infoText.runs}</div>
              <div className="hr16-countdown-runs-label">runs</div>
            </div>
          }
          <span className="hr16-countdown-scheduled">Done</span>
        </div>
      )
    }
    if(e.infoText && e.infoText.type === "valueBoxes"){
      let vals = e.infoText.values
      return(
        <div className="hr16-value-boxes" id={this.getAccumulatedIrrigationInfoBoxId(e)}>
          {!rainSkip && e.infoText.runs != null &&
            <div className="hr16-countdown-runs">
              <div className="hr16-countdown-runs-count">{e.infoText.runs}</div>
              <div className="hr16-countdown-runs-label">{e.infoText.runs === 1 ? "run" : "runs"}</div>
            </div>
          }
          <span className="hr16-value-box">
            {vals[0] != null && <span className="hr16-vb-primary">{vals[0]}</span>}
            {!rainSkip && vals[1] != null &&
              <>
                <span className="hr16-vb-sep"></span>
                <span className="hr16-vb-target material-symbols-outlined" style={{fontSize:"14px"}}>target</span>
                <span className="hr16-vb-secondary">{vals[1]}</span>
              </>
            }
            <span className="hr16-vb-unit">{e.infoText.unit}</span>
          </span>
        </div>
      )
    }
    if(e.infoText && e.infoText.type === "countdown"){
      if(rainSkip) return null
      if(e.chType==="channel_Irrigation_Scheduled" || e.chType==="channel_Irrigation_Scheduled_1900"){
        return(
          <div className="hr16-countdown-single-wrap" id="run-countdown-scheduled">
            {e.infoText.runs != null &&
              <div className="hr16-countdown-runs">
                <div className="hr16-countdown-runs-count">{e.infoText.runs}</div>
                <div className="hr16-countdown-runs-label">runs</div>
              </div>
            }
            <span className="hr16-countdown-scheduled"> {e.infoText.suffix}</span>
          </div>
        )
      }
      let cd = e.infoText.countdown
      let sec = Math.floor(+cd.s || 0)
      let countdownText = `${cd.h}h:${cd.m < 10 ? "0" : ""}${cd.m}m:${sec < 10 ? "0" : ""}${sec}s`
      if(e.chType==="channel_Irrigation_Cycle" && e.infoText.runs != null){
        return(
          <div className="hr16-countdown-single-wrap" title={e.infoText.label} id="run-countdown-cycle">
            <div className="hr16-countdown-runs">
              <div className="hr16-countdown-runs-count">{e.infoText.runs}</div>
              <div className="hr16-countdown-runs-label">runs</div>
            </div>
            <span className="hr16-countdown-single">-{countdownText}</span>
          </div>
        )
      }
      return(
        <div className="hr16-countdown-single-wrap">
          <span className="hr16-countdown-single"> - {countdownText}</span>
        </div>
      )
    }
    if(rainSkip) return null
    return <span className="hr16-info-text">{e.infoText || ""}</span>
  }

  parseSuffixTime=(timeText="")=>{
    let t=String(timeText || "").trim().toUpperCase()
    let m=t.match(/^(\d{1,2}):(\d{2})\s*([AP]M)$/)
    if(!m){
      return {mins: 0, value: "00:00"}
    }
    let h=+m[1]
    let mins=+m[2]
    if(m[3]==="AM"){
      if(h===12) h=0
    }else if(h<12){
      h+=12
    }
    return {
      mins: h * 60 + mins,
      value: `${String(h).padStart(2,"0")}:${String(mins).padStart(2,"0")}`,
    }
  }

  getSharedTimeBoxBg=(mins=0)=>{
    let dayCol = [245, 192, 0, 0.7]
    let nightCol = [192, 130, 209, 0.7]
    return mins < 720 ?
      interpolateColor(nightCol, dayCol, mins / 720) :
      interpolateColor(dayCol, nightCol, (mins - 720) / 720)
  }

  renderSharedTimeBox=(suffix, className="")=>{
    let {mins, value}=this.parseSuffixTime(suffix)
    return(
      <div className={`hr16-time-wrap ${className}`.trim()}>
        <div className="time-enable">
          <C18MuiPickersUtilsProvider utils={DateFnsUtils}>
            <C18MuiTimePicker
              ampm={true}
              openTo="hours"
              views={["hours", "minutes"]}
              format="HH:mm"
              label=""
              value={value}
              onChange={()=>{}}
              disabled={true}
              saveOK={true}
              bgColor={this.getSharedTimeBoxBg(mins)}
              inputProps={{
                style: {textAlign: "center", width: 100, color: "#393D46"}
              }}
            />
          </C18MuiPickersUtilsProvider>
        </div>
      </div>
    )
  }

  showEquipmentRow=(alarmClass,e,onClass,i,i2)=>{// i2 is the actual index
// new and added:
//   <tr><td><a href="" class="name">1. Exhaust Variable Speed</a></td><td><span class="on-off-indicator">OFF</span></td>
//     <td><C18Button00 type="button" href="" class="info-button" aria-label="info" disabled>i</C18Button00></td></tr> <!-- MODIFIED: ADDED DISABLED ATTRIBUTE IF NO INFO -->
//   <tr class="equip-hidden-info"><td colspan=3><span>pH Setpoint: 6.0, pH Reading: 5, alternate readings: 0,0, tank level: 0.3 gal, some other info</span></td></tr>
    let showInfo=(e.showInfo)?" show-details":""
//     cl(e)
//     progPos=(+e.pos)?1:0
    let selected=(this.state.waterNowChannelId && (+this.state.waterNowChannelId===+e.id))?" equipment-water-now-selected":""
    let isWateringNow=(+e.overrideType===25) ||
      (!!this.state.waterNowPending && e.chan===this.state.waterNowActiveChan)
    let isWalkValve=isConfiguredEquipmentChannel(e) && (
      (+e.overrideType===26) ||
      (!!this.state.walkValvePending && e.chan===this.state.walkValveActiveChan)
    )
    let isAuxOverride=(+e.overrideType===10)
    let wateringNow=(isWateringNow||isWalkValve) ? " equipment-row-active" : (isAuxOverride ? " " : "")
    let rainSkipDisabled=""
    let override=((+e.reportedPos)!=e.relState)?
//       " forced":
      (e.swPos?" forced":""):
      (e.swPos)?" non-auto":" auto"
//     let forced=(e.swPos)?" forced":""
    // cl(override)
    if(e.type==constant.EQ_NONE){override=""}
    let mainRow=(
      <tr key={i+i2} className={alarmClass+showInfo+selected+wateringNow+rainSkipDisabled}>
        <td style={{minWidth:'100px'}}>
          <C18Anchor00 to="" className="name" translate="no" onClick={(ev)=>
            this.onClick("equip",ev,e)}>
              {`${e.id}. ${(e.name)?e.name:"None"}`}
          </C18Anchor00>
        </td>
         <td>
          <C18Anchor00 to="" className={`on-off-indicator${onClass}`} onClick={(ev)=>
            this.onClick("equip",ev,e)}>
            {`${e.system}`}
          </C18Anchor00>
         </td>
        {this.state.isHR16 ? (
          <>
            <td className="info-cell">
              {this.renderInfoCell(e, isWateringNow, isWalkValve)}
            </td>
          </>
        ) : (
          <td>
            <C18Button00 type="button" className={`info-button${override}`} aria-label="info"
              onClick={(ev)=>
                this.onClick("info",ev,e,i2)}>i
            </C18Button00>
          </td>
        )}
      </tr>
    )
    if(this.state.isHR16){
      return mainRow
    }
    return(
      [
        mainRow,
        <tr key={(i+i2)+ "b"} className="equip-hidden-info">
          <td colSpan={3}>
            <span>
              {`${e.status} ${([" non-auto", " forced"].includes(override)) ? `, ${
              e.auto}`: ""}`}
            </span>
          </td>
        </tr>
      ]
    )
  }
  
  showTwoEquipment=(col)=>{
    let equip=[]
    let equipLength=this.state.equipment.length
    let colLength=Math.floor((equipLength+1)/2)
    for(let i=0;i<colLength;i++){
      let i2=i+i+col;
      if(i2<equipLength){
        let e=this.state.equipment[i2]
//         cl(e.system)
        let onClass=(["OFF","0%","Force OFF"].includes(e.system)/*=="OFF"*/)?"":" on"
        let alarmClass=(e.alarm)?"alarm-on":""
        equip.push(this.showEquipmentRow(alarmClass,e,onClass,i,i2))
//         equip.push(
//           <tr key={i2} className={alarmClass}><td><span className="name">{`${e.id}. ${e.name}`}</span></td><td><span className={`on-off-indicator${onClass}`}>{e.system}</span></td><td><span className="info-button">i</span></td></tr>
//         )
      }else{
        equip.push(
          <tr key={i2}><td></td>{this.state.isHR16 && <td></td>}<td></td><td></td></tr>
        )
      }
    }
    return(
      <table className="list"><tbody>
        {this.state.isHR16 ? (
          <tr><th>Name</th><th>Status</th><th>Info</th></tr>
        ) : (
          <tr><th>Name</th><th>Status</th><th></th></tr>
        )}
        {equip}
      </tbody></table>
    )
  }
  
  showEquipmentTwoColumn=()=>{
    return(
      <section className="link4">
        <div className="section-header equipment-header-row" style={{display:"flex", alignItems:"center", justifyContent:"space-between", gap:12}}>
          <C18DateFormat00 parms={{
            leftString: dateToDisplayDate(new Date(),"mm/dd/yyyy h:mm ap"),
            leftClass: "date",
            type: "wrench",
            ariaLabel: "equipment settings",
            value: this.state.tileMode,
            valueId: "tileMode",
            onChange: (val)=>this.props.parms.onChange({cmd:"equipmentWrench", val:val})
          }}/>
          <div className="zone-actions-bar">
            {this.renderWaterNowActions()}
            {this.renderWaterBudgetActions()}
            {this.state.isHR16 && this.state.actionsExpanded && (
              <>
                {this.renderRainSkipActions()}
                {this.renderWalkValveActions()}
              </>
            )}
            {this.state.isHR16 && (
              <button
                type="button"
                className="actions-toggle-btn"
                onClick={() => this.setState(s => ({ actionsExpanded: !s.actionsExpanded }))}
                aria-label={this.state.actionsExpanded ? "Hide Rain Skip and Walk Valve" : "Show Rain Skip and Walk Valve"}
                title={this.state.actionsExpanded ? "Show less" : "Show more"}
              >
                {this.state.actionsExpanded ? "−" : "+"}
              </button>
            )}
          </div>
         
          {this.renderWaterBudgetStatusBar()}
          {this.renderAuxWaterBudgetStatusBar()}
          {this.renderRainSkipStatusBar()}
        </div>
        <div className={`two-column-equipment-list${this.isRainSkipActive() ? " rain-skip-grayed" : ""}`}>
          <div className="left-column">
            {this.showTwoEquipment(0)}
          </div>
          <div className="right-column">
            {this.showTwoEquipment(1)}
          </div>
        </div>
        {this.renderWaterNowPopup()}
        {this.renderRainSkipPopup()}
        {this.renderWalkValvePopup()}
        {this.renderWaterBudgetPopup()}
      </section>
    )
  }
  
  render(){
//     cl(this.state)
//     cl(this.props)
    if(this.state.loaded){
      if(this.props.parms.cols==1){
        return this.showEquipmentOneColumn()
      }else{
        return this.showEquipmentTwoColumn()
      }
    }else{
      return <LoadingSpinner message="loading equipment..." />
    }
  }
}
      
export default C18ZoneEquipment00;
